module.exports = __webpack_public_path__ + "assets/images/02_f786eec8b680255b7c5c9216284b0411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-2/02.png
// module id = 234
// module chunks = 0